// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".client-Components-Calendar-Week-module__root--ht4iF {\n  display: contents;\n}\n/*# sourceMappingURL=Week.module.css.map */", "",{"version":3,"sources":["webpack://./Week.module.less","webpack://./client/Components/Calendar/Week.module.less"],"names":[],"mappings":"AAAA;EACC,iBAAA;ACCD;AACA,0CAA0C","sourcesContent":[".root {\n\tdisplay: contents;\n}",".root {\n  display: contents;\n}\n/*# sourceMappingURL=Week.module.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "client-Components-Calendar-Week-module__root--ht4iF"
};
export default ___CSS_LOADER_EXPORT___;
